import React, { Fragment } from 'react';
import { useTimezone } from '../hooks/useTimezone';
interface AnnouncementBarProps {
  timeLeft: string;
}
export function AnnouncementBar({
  timeLeft
}: AnnouncementBarProps) {
  const {
    dayName
  } = useTimezone();
  const text = dayName ? `¡OFERTA 4X1 SOLO POR HOY ${dayName.toUpperCase()}!` : `¡OFERTA 4X1 SOLO POR HOY!`;
  const segment = <span className="inline-flex items-center gap-3" data-id="element-1">
      <span className="text-[#c8b89a] font-bold font-mono text-xs md:text-sm tracking-widest uppercase" data-id="element-2">
        {text}
      </span>
      <span className="text-[#cc2200] text-base" data-id="element-3">⚡</span>
      <span className="text-[#c8b89a] font-bold font-mono text-xs md:text-sm tracking-widest uppercase" data-id="element-4">
        Finaliza en {timeLeft}
      </span>
      <span className="text-[#cc2200] text-base mx-2" data-id="element-5">⚡</span>
    </span>;
  return <div className="fixed top-0 left-0 right-0 z-50 overflow-hidden bg-[#0a0a0a] border-b border-[#cc2200]/60" style={{
    height: '36px'
  }} aria-label="Anuncio de oferta" data-id="element-6">
      <div className="flex items-center h-full whitespace-nowrap announcement-track" data-id="element-7">
        {Array(12).fill(null).map((_, i) => <Fragment key={i} data-id="element-8">{segment}</Fragment>)}
        {/* Duplicate for seamless loop */}
        {Array(12).fill(null).map((_, i) => <Fragment key={`dup-${i}`} data-id="element-9">{segment}</Fragment>)}
      </div>
    </div>;
}